import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../firebase';
import "../App.css";
import Reportmenu from '../panel/Reportmenu';
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';

function Backdatereport() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchUsers()
        });
    });
    const printRef = useRef();
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const [username, setusername] = useState("");
    const [bookingData, setbookingData] = useState([]);
    const [serviceData, setserviceData] = useState([]);
    const [payhistory, setpayhistory] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [total, settotal] = useState(0);

    const [allllserviuceamount, setallllserviuceamount] = useState(0)
    const [alladults, setalladults] = useState(0)
    const [allchilds, setallchilds] = useState(0)
    const [allllroomamount, setallllroomamount] = useState(0)
    const [allllfoodamount, setallllfoodamount] = useState(0)
    const [alllltotalamount, setalllltotalamount] = useState(0)
    const [roomscount, setroomscount] = useState(0)

    const fetchUsers = async () => {
        try {
            if (!userData || !loadincount) return;

            // --- 1. SETUP DATES & TIME ---
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const tomorrow = new Date(today);
            tomorrow.setDate(tomorrow.getDate() + 1);
            const todayTimestamp = Timestamp.fromDate(today);
            const tomorrowTimestamp = Timestamp.fromDate(tomorrow);
            const reportDate = moment().subtract(1, 'days').format('YYYY-MM-DD');

            // --- 2. INITIAL PARALLEL FETCHES (User Data, Pay History, Services) ---
            const userDocRef = doc(db, "users", userData.uid);

            const [userDocSnap, payHistorySnapshot, servicesSnapshot] = await Promise.all([
                getDoc(userDocRef),
                getDocs(
                    query(
                        collection(db, "payhistory"),
                        where("uid", "==", userData.uid),
                        where("createdAt", ">=", todayTimestamp),
                        where("createdAt", "<", tomorrowTimestamp),
                        where("paymenttype", "==", "B"),
                        where("status", "==", "Working"),
                    )
                ),
                getDocs(
                    query(
                        collection(db, "bookingservices"),
                        where("uid", "==", userData.uid),
                        where("type", "==", "Booking"),
                        where("createdAt", ">=", todayTimestamp),
                        where("createdAt", "<", tomorrowTimestamp),
                    )
                )
            ]);

            if (userDocSnap.exists()) {
                setusername(userDocSnap.data().username);
                setloadincount(false);
            }

            // --- 3. PRE-FETCH LOOKUP DATA FOR PAY HISTORY ---
            const payHistoryDocs = payHistorySnapshot.docs;
            const bookingIdsToFetch = new Set(payHistoryDocs.map(doc => doc.data().bookingid).filter(id => id));
            const paymodeIdsToFetch = new Set();
            payHistoryDocs.forEach(doc => {
                const data = doc.data();
                if (data.paymode1) paymodeIdsToFetch.add(data.paymode1);
                if (data.paymode2) paymodeIdsToFetch.add(data.paymode2);
            });

            const [
                allPaymentModesSnapshot,
                bookingsLookupSnapshot
            ] = await Promise.all([
                getDocs(collection(db, "paymentmodes")),
                bookingIdsToFetch.size > 0 ? getDocs(query(collection(db, "bookings"), where('__name__', 'in', Array.from(bookingIdsToFetch)))) : { docs: [] }
            ]);

            const paymentModeLookup = allPaymentModesSnapshot.docs.reduce((acc, doc) => {
                acc[doc.id] = doc.data().paymode;
                return acc;
            }, {});
            const bookingDataLookup = bookingsLookupSnapshot.docs.reduce((acc, doc) => {
                acc[doc.id] = doc.data();
                return acc;
            }, {});

            // --- 4. PROCESS PAY HISTORY WITH LOOKUPS (FAST) ---
            const payHistoryData = payHistoryDocs.map((doc1) => {
                const docData = doc1.data();
                const paymode1 = paymentModeLookup[docData.paymode1] || "";
                const paymode2 = paymentModeLookup[docData.paymode2] || "";
                const date = docData.createdAt.toDate();
                const formattedDate = moment(date).format('DD-MM-YYYY HH:mm:ss');

                let bookingData = {};
                const bookingDocData = bookingDataLookup[docData.bookingid];

                if (bookingDocData) {
                    bookingData = {
                        rooms: bookingDocData.rooms || [],
                        checkinDate: bookingDocData.checkindate || null,
                        checkoutDate: bookingDocData.checkoutdate || null,
                        custName: bookingDocData.customers?.custname || ""
                    };
                }

                return {
                    id: doc1.id,
                    data: docData,
                    paymode1,
                    paymode2,
                    createdat: formattedDate,
                    bookingData
                };
            });
            setpayhistory(payHistoryData);

            // --- 5. CALCULATE PAYMENT MODE TOTALS (FAST) ---
            // Reuse paymentModeLookup for mode names
            const paymentModeTotals = allPaymentModesSnapshot.docs.map(modeDoc => {
                let total1 = 0;
                let total2 = 0;
                const paymodeId = modeDoc.id;

                payHistoryData.forEach(pay => {
                    if (pay.data.paymode1 === paymodeId) {
                        total1 += pay.data.amount1 || 0;
                    }
                    if (pay.data.paymode2 === paymodeId) {
                        total2 += pay.data.amount2 || 0;
                    }
                });

                return {
                    id: paymodeId,
                    paymode: paymentModeLookup[paymodeId] || "",
                    totalamount: (total1 + total2).toFixed(2)
                };
            });
            setpaymodes(paymentModeTotals);
            const totalAmount = paymentModeTotals.reduce((sum, data) => sum + parseFloat(data.totalamount), 0);
            settotal(totalAmount.toFixed(0));


            // --- 6. PROCESS BOOKING SERVICES ---
            const serviceData = servicesSnapshot.docs.map((doc) => {
                const data = doc.data();
                const createdAt = data.createdAt;
                const entryTime = createdAt ? createdAt.toDate() : null;
                const entryTimeFomat = moment(entryTime).format('DD-MM-YYYY hh:mm:ss A');
                return {
                    id: doc.id,
                    data: data,
                    entryTime: entryTimeFomat,
                };
            });
            setserviceData(serviceData);

            // --- 7. FETCH CHECKIN DETAILS & BOOKING DATA FOR REPORT ---
            const [checkinDetailsBookedSnapshot, checkinDetailsCheckoutSnapshot] =
                await Promise.all([
                    getDocs(
                        query(
                            collection(db, "checkindetails"),
                            where("status", "==", "Booked"),
                            where("uid", "==", userData.uid),
                            where("checkindate", "==", reportDate),
                            orderBy("createdAt", "asc") // ✅ ASCENDING
                        )
                    ),
                    getDocs(
                        query(
                            collection(db, "checkindetails"),
                            where("status", "==", "Checkout"),
                            where("uid", "==", userData.uid),
                            where("checkindate", "==", reportDate),
                            orderBy("createdAt", "asc") // ✅ ASCENDING
                        )
                    ),
                ]);


            const checkinDetailsData = [
                ...checkinDetailsCheckoutSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })),
                ...checkinDetailsBookedSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
            ];

            const uniqueCheckinDetails = Array.from(new Map(checkinDetailsData.map(item => [item.bookingid, item])).values());
            const reportBookingIds = uniqueCheckinDetails.map(doc => doc.bookingid).filter(id => id);

            if (reportBookingIds.length === 0) {
                setbookingData([]);
                return;
            }

            // --- 8. BULK FETCH BOOKINGS AND ORDERS FOR REPORT ---
            const [reportBookingsSnapshot, ordersSnapshot] = await Promise.all([
                getDocs(query(collection(db, 'bookings'), where('__name__', 'in', reportBookingIds))),
                getDocs(query(collection(db, 'orders'), where('status', '==', 'Bill Pending'), where('orderdate', '==', reportDate), where('bookingId', 'in', reportBookingIds)))
            ]);

            const bookingsDataMap = reportBookingsSnapshot.docs.reduce((acc, doc) => {
                acc[doc.id] = { id: doc.id, ...doc.data() };
                return acc;
            }, {});

            // Calculate total food amount per booking from the bulk order fetch
            const foodTotalsMap = ordersSnapshot.docs.reduce((acc, doc) => {
                const data = doc.data();
                const bookingId = data.bookingId;
                acc[bookingId] = (acc[bookingId] || 0) + (data.totalamount || 0);
                return acc;
            }, {});

            // Create a map of payment history by bookingId for the report
            const paymentHistoryMap = payHistoryData.reduce((acc, pay) => {
                const bookingId = pay.data.bookingid;
                if (bookingsDataMap[bookingId]) {
                    if (!acc[bookingId]) acc[bookingId] = [];
                    acc[bookingId].push(pay);
                }
                return acc;
            }, {});


            // --- 9. COMBINE DATA AND CALCULATE FINALS (FAST) ---
            let allllroomamount = 0;
            let allllfoodamount = 0;
            let alllltotalamount = 0;
            let allllalltoal = 0;
            let allllpaidamount = 0;
            let allllserviceamount = 0;
            let allllpending = 0;
            let noofroomscount = 0;
            let alladults = 0;
            let allchilds = 0;

            const combinedData = uniqueCheckinDetails.map((checkinDetail) => {
                const bookingData = bookingsDataMap[checkinDetail.bookingid];
                if (!bookingData) return null; // Skip if booking data wasn't found (shouldn't happen with the bulk fetch)

                const roomamount = bookingData.rooamount || 0;
                const date1 = moment(bookingData.checkindate, 'YYYY-MM-DD');
                const date2 = moment(reportDate, 'YYYY-MM-DD');

                let dayDifference = date2.diff(date1, 'days');
                if (dayDifference === 0) dayDifference = 1;
                let serviceamount = 0;

                if (bookingData.services && bookingData.services.length > 0) {

                    bookingData.services.forEach((item) => {

                        if (!item.createdAt) return;

                        const serviceDate = moment(item.createdAt.toDate()).format("YYYY-MM-DD");

                        if (serviceDate === reportDate) {
                            serviceamount += parseFloat(item.servicerate || 0);
                        }

                    });

                }
                const foodTotal = foodTotalsMap[checkinDetail.bookingid] || 0; // FAST LOOKUP

                // Payment history calculation
                const paymentHistory = paymentHistoryMap[checkinDetail.bookingid] || [];
                const paidAmount = paymentHistory.reduce((sum, pay) => sum + pay.data.amount1 + pay.data.amount2, 0);

                const totalamount = parseFloat(roomamount) + parseFloat(serviceamount) + parseFloat(foodTotal);
                const alltoal = parseFloat(totalamount) * parseFloat(dayDifference);
                const remaining = parseFloat(alltoal) - parseFloat(paidAmount);

                // Tallying totals
                allllroomamount += parseFloat(roomamount);
                allllfoodamount += parseFloat(foodTotal);
                alllltotalamount += parseFloat(totalamount);
                allllalltoal += parseFloat(alltoal);
                allllpaidamount += parseFloat(paidAmount);
                allllserviceamount += parseFloat(serviceamount);
                allllpending += parseFloat(remaining);
                noofroomscount += parseFloat(bookingData.rooms.length);
                alladults += parseFloat(bookingData.adults);
                allchilds += parseFloat(bookingData.childs);

                return {
                    ...checkinDetail,
                    booking: bookingData,
                    serviceamount: serviceamount.toFixed(0),
                    roomamount: roomamount.toFixed(0),
                    foodamount: foodTotal.toFixed(0),
                    totalamount: totalamount.toFixed(0),
                    alltoal: alltoal.toFixed(0),
                    paidamount: paidAmount.toFixed(0),
                    pending: remaining.toFixed(0),
                    todayDays: dayDifference,
                    paymentHistory
                };
            }).filter(item => item !== null);

            // --- 10. FINAL STATE UPDATES ---
            setallllroomamount(allllroomamount.toFixed(0));
            setallllfoodamount(allllfoodamount.toFixed(0));
            setalllltotalamount(alllltotalamount.toFixed(0));
            setallllserviuceamount(allllserviceamount.toFixed(0));
            setroomscount(noofroomscount.toFixed(0));
            setallchilds(allchilds.toFixed(0));
            setalladults(alladults.toFixed(0));
            setbookingData(combinedData);

        } catch (error) {
            console.error("Error in fetchUsers:", error);
        }
    };

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })


    return (
        <div>
            <Reportmenu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline" ref={printRef}>
                                    <div className="card-body">
                                        <div className="row invoice-info">
                                            <div className="col-sm-12 invoice-col text-center">
                                                <address>
                                                    <h4>Dasara Executive</h4>
                                                    Chatrapati Shivaji Maharaj Chouk, Tuljapur, Dist - Dharashiv, MH - 413601<br />
                                                    Phone: +91 9975294940 |
                                                    Email:  dasaraexecutive@gmail.com<br />
                                                    Website:  www.dasaraexecutive.com
                                                </address>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <table className='table table-bordered'>
                                                <tr>
                                                    <th width="33.33%" style={{ textAlign: "center" }}>Report Date : {moment().format('DD-MM-YYYY')} {moment().format('HH:mm:ss A')} </th>
                                                    <th width="33.33%" style={{ textAlign: "center" }}><h5 style={{ textTransform: "uppercase" }}>  DAILY REPORT  </h5></th>
                                                    <th width="33.33%" style={{ textAlign: "center" }}>Receptionist : {username}</th>
                                                </tr>
                                            </table>
                                            <table className="customers">
                                                <thead>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#E0FCFE" }} colSpan={14}>Booking Report</th>
                                                    </tr>
                                                    <tr>
                                                        <th>Sr No</th>
                                                        <th>Customer Name </th>
                                                        <th>Checkin Date </th>
                                                        <th>Checkout Date </th>
                                                        <th> Days </th>
                                                        <th>Rooms </th>
                                                        <th style={{ textAlign: "right" }}>Persons</th>
                                                        <th style={{ textAlign: "right" }}>Amount </th>
                                                        <th style={{ textAlign: "right" }}>Extra </th>
                                                        <th style={{ textAlign: "right" }}>Total</th>
                                                        <th style={{ textAlign: "center" }}>Payments</th>
                                                        {/* <th>Status</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        bookingData.map((item, num = 1) => {
                                                            return (
                                                                <tr key={num + 1}>
                                                                    <td width="80">{num + 1}</td>
                                                                    <td style={{ textTransform: "capitalize" }}>{item.booking.customers.custname}</td>
                                                                    <td>{moment(item.checkindate).format('DD/MM/YYYY')} {item.checkintime}</td>
                                                                    <td>{moment(item.checkoutdate).format('DD/MM/YYYY')} {item.checkouttime}</td>
                                                                    <td> 1</td>
                                                                    <td>
                                                                        {item.booking.rooms.map((item1, index) =>
                                                                            <span key={index}>&nbsp; {item1.roomname} ({parseFloat(item1.discount)}%)<br /> </span>
                                                                        )}
                                                                    </td>
                                                                    <td style={{ textAlign: "right" }}>{item.booking.adults} (A) / {item.booking.childs} (C)</td>
                                                                    <td style={{ textAlign: "right" }}>{item.roomamount}</td>
                                                                    <td style={{ textAlign: "right" }}>{item.serviceamount}</td>
                                                                    <td style={{ textAlign: "right" }}>{item.totalamount}</td>
                                                                    <td style={{ textAlign: "right" }}>

                                                                        {
                                                                            item.paymentHistory.length > 0 ?
                                                                                <>
                                                                                    {
                                                                                        item.paymentHistory.map((itemmm, index) =>
                                                                                            <>
                                                                                                {
                                                                                                    parseFloat(itemmm.data.amount1) > 0 &&
                                                                                                    <b>{itemmm.paymode1} : {parseFloat(itemmm.data.amount1).toFixed(0)} <br /></b>
                                                                                                }
                                                                                                {
                                                                                                    parseFloat(itemmm.data.amount2) > 0 &&
                                                                                                    <b>{itemmm.paymode2} : {parseFloat(itemmm.data.amount2).toFixed(0)}</b>
                                                                                                }
                                                                                            </>
                                                                                        )
                                                                                    }
                                                                                </> :
                                                                                <b style={{ color: "red" }}>Pending</b>
                                                                        }

                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                        )}
                                                    <tr>
                                                        <th colSpan={5} style={{ textAlign: "right" }}> TOTAL</th>
                                                        <th>{roomscount} </th>
                                                        <th style={{ textAlign: "right" }}>{alladults} (A) / {allchilds} (C)</th>
                                                        <th style={{ textAlign: "right" }}>{allllroomamount} </th>
                                                        <th style={{ textAlign: "right" }}>{allllserviuceamount} </th>
                                                        <th style={{ textAlign: "right" }}>{alllltotalamount} </th>
                                                        <th></th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            
                                            <table className="customers">
                                                <thead>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#E0FCFE" }} colSpan={14}>Collection Report</th>
                                                    </tr>
                                                    <tr>
                                                        <th>Custname</th>
                                                        <th>Room</th>
                                                        <th>Checkin</th>
                                                        <th>Checkout</th>
                                                        <th>Paymode1</th>
                                                        <th>Amount1</th>
                                                        <th>Paynote1</th>
                                                        <th>Paymode2</th>
                                                        <th>Amount2</th>
                                                        <th>Paynote2</th>
                                                        <th>Datetime</th>
                                                        <th>Note</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        payhistory.map((item, index) =>
                                                            <tr key={index}>
                                                                <td>{item.bookingData.custName}</td>
                                                                <td>
                                                                    {item.bookingData.rooms.map((item1, index) =>
                                                                        <span key={index}>{item1.roomname} <br />  </span>
                                                                    )}
                                                                </td>
                                                                <td>{moment(item.bookingData.checkinDate).format('DD-MM-YYYY')}</td>
                                                                <td>{moment(item.bookingData.checkoutDate).format('DD-MM-YYYY')}</td>
                                                                <td>{item.paymode1}</td>
                                                                <td>{item.data.amount1}</td>
                                                                <td>{item.data.paytime1}</td>
                                                                <td>{item.paymode2}</td>
                                                                <td>{item.data.amount2}</td>
                                                                <td>{item.data.paytime2}</td>
                                                                <td>{item.createdat}</td>
                                                                <td>{item.data.note}</td>
                                                                {/* <td>{item.data.username}</td> */}
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                            <table className='customers'>
                                                <thead>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#E0FCFE" }} colSpan={paymodes.length + 1}>Paymode Wise Collection</th>
                                                    </tr>
                                                    <tr>
                                                        <th>Paymodes</th>
                                                        {
                                                            paymodes.map((item, index) =>
                                                                <>
                                                                    {
                                                                        item.totalamount > 0 &&
                                                                        <th key={index}>{item.paymode}</th>
                                                                    }
                                                                </>
                                                            )
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <th>Amount</th>
                                                        {
                                                            paymodes.map((item, index) =>
                                                                <>
                                                                    {
                                                                        item.totalamount > 0 &&
                                                                        <th key={index}>{item.totalamount}</th>
                                                                    }
                                                                </>
                                                            )
                                                        }

                                                    </tr>
                                                </thead>
                                            </table><br />
                                            <table className='customers'>
                                                <thead>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#E0FCFE" }}> <h6> Total Collection of {username} :  Rs. {total} /- </h6></th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>

                                </div>
                                <center>
                                    <button className='btn btn-success' onClick={handlePrint}>Print Report</button>
                                </center>
                            </div>
                        </div>
                    </div>
                </section >
            </div>
        </div >

    )
}

export default Backdatereport
